"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressReadOnlyToJSON = exports.AddressReadOnlyFromJSONTyped = exports.AddressReadOnlyFromJSON = void 0;
var runtime_1 = require("../runtime");
function AddressReadOnlyFromJSON(json) {
    return AddressReadOnlyFromJSONTyped(json, false);
}
exports.AddressReadOnlyFromJSON = AddressReadOnlyFromJSON;
function AddressReadOnlyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'salutation': !(0, runtime_1.exists)(json, 'salutation') ? undefined : json['salutation'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
        'isParcelShop': json['isParcelShop'],
        'isDefaultAddress': !(0, runtime_1.exists)(json, 'isDefaultAddress') ? undefined : json['isDefaultAddress'],
        'isInvoiceToAddress': !(0, runtime_1.exists)(json, 'isInvoiceToAddress') ? undefined : json['isInvoiceToAddress'],
        'isReadOnly': !(0, runtime_1.exists)(json, 'isReadOnly') ? undefined : json['isReadOnly'],
    };
}
exports.AddressReadOnlyFromJSONTyped = AddressReadOnlyFromJSONTyped;
function AddressReadOnlyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'salutation': value.salutation,
        'country': value.country,
        'isParcelShop': value.isParcelShop,
        'isDefaultAddress': value.isDefaultAddress,
        'isInvoiceToAddress': value.isInvoiceToAddress,
        'isReadOnly': value.isReadOnly,
    };
}
exports.AddressReadOnlyToJSON = AddressReadOnlyToJSON;
//# sourceMappingURL=AddressReadOnly.js.map